var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"flex bg-secondary py-4 md:py-8 px-4 md:px-8 lg:px-16"},[_c('h1',{staticClass:"text-primary",domProps:{"textContent":_vm._s(_vm.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }